import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {ENGAGEMENT_SOURCE_LOCATION, IMenuItem, ITrendingItem, MenuStore, mergeAndAdd} from '../../store';
import {IBaseResponse, ItemService, WebService} from '../../services';
import {ITrendingItemWithOptions} from './interfaces/ITrendingItemWithOptions';
import {cloneDeep} from 'lodash';

export interface ITrendingItemStoreState {
	trendingItems: ITrendingItem[];
}

@Module({name: 'trendingItems', namespaced: true})
class TrendingItemModule extends VuexModule implements ITrendingItemStoreState {
	trendingItems: ITrendingItem[] = [];
	trendingItemsWithOptions: ITrendingItemWithOptions[] = [];

	get isTrending() {
		return (itemId: string) => {
			return this.trendingItems.some((trendingItem) => {
				return trendingItem.itemId === itemId;
			});
		};
	}

	get trendingItemList() {
		if(MenuStore.menu && MenuStore.menu.items) {
			const menuItems: IMenuItem[] = [];
			for(const trendingItem of this.trendingItems) {
				const menuItem = MenuStore.item(trendingItem.itemId);
				if(menuItem) {
					const clone = cloneDeep(menuItem);
					if(clone.lineItem) {
						clone.lineItem.engagementSource = ItemService.lineItemEngagementSourceFromTrendingItem(trendingItem, ENGAGEMENT_SOURCE_LOCATION.TRENDING);
						menuItems.push(clone);
					}
				}
			}
			return menuItems;
		}
		return [];
	}

	@Action
	async fetchTrendingItems(locationId: string) {
		// This request can fire right as the app starts up so it need to wait for
		// the logged in client to be ready.
		await WebService.loggedInStarted;
		const response = await WebService.authenticatedClient.get<IBaseResponse<{trendingItems: ITrendingItem[]}>>(`locations/${locationId}/trending_items`);
		this.setTrendingItems(response.data.data.trendingItems);
	}

	@Action
	async fetchTrendingItemsWithOptions(locationId: string) {
		// This request can fire right as the app starts up so it need to wait for
		// the logged in client to be ready.
		await WebService.loggedInStarted;
		const response = await WebService.authenticatedClient.get<IBaseResponse<{trendingItemsWithOptions: ITrendingItemWithOptions[]}>>(`locations/${locationId}/trending_items_with_options`);
		this.setTrendingItemsWithOptions(response.data.data.trendingItemsWithOptions);
	}

	@Mutation
	public setTrendingItems(trendingItems: ITrendingItem[]) {
		this.trendingItems = trendingItems;
	}

	@Mutation
	public addTrendingItem(trendingItem: ITrendingItem) {
		mergeAndAdd(this.trendingItems, [trendingItem], ['itemId']);
	}

	@Mutation
	public clearTrendingItems() {
		this.trendingItems = [];
	}

	@Mutation
	public setTrendingItemsWithOptions(trendingItems: ITrendingItemWithOptions[]) {
		this.trendingItemsWithOptions = trendingItems;
	}

	@Mutation
	public clearTrendingItemsWithOptions() {
		this.trendingItemsWithOptions = [];
	}
}


export {
	TrendingItemModule
};
